import React, { useState, useEffect, memo, useRef } from "react";
import { Modal, Form, Col, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Select, TimePicker } from "antd";
import CustomSuffixIcon from "../../popups/CustomSuffixIcon";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { specialityList } from "../../popups/NewAppointment";
import { useDispatch, useSelector } from "react-redux";
import { openToModifyWaitlist } from "../../../StateManagement/Reducers/ScheduleWidgetState";
import moment from "moment";

const { Option } = Select;

function WaitlistModal({
  setAddModalShow,
  dataFetch,
  id = 0,
  row,
  setSuccessAlertShow,
  setSuccessMsg,
}) {
  //-------------------------------------------UseState Start--------------------------------------------------------
  // Form state
  const dispatch = useDispatch();

  const [patientId, setPatientId] = useState(row?.patient_id || "");
  const [patientSearch, setPatientSearch] = useState("");
  const [apptType, setApptType] = useState(row?.appt_type || "");
  const [facility, setFacility] = useState(row?.facility || "");
  const [provider, setProvider] = useState(row?.provider || "");
  const [apptDate, setApptDate] = useState(row?.appt_date || "");
  const lastFacilityRef = useRef(facility);
  const [prefStartTime, setPrefStartTime] = useState(
    row?.pref_start_time || ""
  );
  const [prefEndTime, setPrefEndTime] = useState(row?.pref_end_time || "");
  const [priority, setPriority] = useState(row?.priority || "");
  const [speciality, setSpeciality] = useState(row?.speciality || "");
  const [reason, setReason] = useState(row?.reason || "");
  const [apptProfile, setApptProfile] = useState(row?.appt_profile || "");
  const [selectedPatient, setSelectedPatient] = useState(null);

  // Error states
  const [errors, setErrors] = useState({
    patientId: "",
    apptType: "",
    facility: "",
    provider: "",
    apptDate: "",
    priority: "",
    speciality: "",
    apptProfile: "",
    fromTime: "",
    toTime: "",
  });

  // Dropdown options state
  const [patients, setPatients] = useState([]);
  const apptTypes = [
    { id: 0, name: "Appointment" },
    { id: 1, name: "Walk-in" },
    { id: 2, name: "Telehealth" },
  ];
  const [facilities, setFacilities] = useState([]);
  const [providers, setProviders] = useState([]);
  const priorities = [
    { id: 1, name: "Urgent" },
    { id: 2, name: "High" },
    { id: 3, name: "Medium" },
    { id: 4, name: "Low" },
  ];
  const [apptProfiles, setApptProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");

  const timeoutRef = useRef(null);

  //-------------------------------------------UseState End--------------------------------------------------------

  //-------------------------------------------Function Start--------------------------------------------------------

  // Validation function
  const validateForm = () => {
    const newErrors = {
      patientId: "",
      apptType: "",
      facility: "",
      provider: "",
      apptDate: "",
      priority: "",
      speciality: "",
      apptProfile: "",
    };

    let isValid = true;

    if (!selectedPatient || !patientId) {
      newErrors.patientId = "Patient name is required";
      isValid = false;
    }

    if (!apptType && apptType !== 0) {
      newErrors.apptType = "Appointment type is required";
      isValid = false;
    }

    if (!facility) {
      newErrors.facility = "Facility is required";
      isValid = false;
    }

    if (!provider) {
      newErrors.provider = "Provider is required";
      isValid = false;
    }

    if (!apptDate) {
      newErrors.apptDate = "Date is required";
      isValid = false;
    }

    if (!priority && priority !== 0) {
      newErrors.priority = "Priority is required";
      isValid = false;
    }

    if (!speciality) {
      newErrors.speciality = "Specialty is required";
      isValid = false;
    }

    if (!apptProfile) {
      newErrors.apptProfile = "Appointment profile is required";
      isValid = false;
    }

    if (!prefStartTime) {
      newErrors.fromTime = "From time is required";
      isValid = false;
    }

    if (!prefEndTime) {
      newErrors.toTime = "To time is required";
      isValid = false;
    }

    if (!validateTimeRange()) {
      newErrors.toTime = "To time has to be greater than from time";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const facilityObj = facilities.find(
    (fac) => String(fac.id) === String(facility)
  );

  const fullFacName = facilityObj?.name || row?.facility_name || "";

  // Clear specific error when field is focused/changed
  const clearError = (fieldName) => {
    setErrors((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };

  const validateTimeRange = () => {
    const newErrors = {};

    if (!prefStartTime) {
      newErrors.fromTime = "From Time is required";
    }

    if (!prefEndTime) {
      newErrors.toTime = "To Time is required";
    } else if (prefStartTime && prefEndTime <= prefStartTime) {
      newErrors.toTime = "To Time must be after From Time";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const OnSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setSubmitLoading(true);

    const article = {
      patient_id: patientId,
      appt_type: apptType,
      facility: facility,
      provider: provider,
      appt_date: apptDate,
      pref_start_time: prefStartTime,
      pref_end_time: prefEndTime,
      priority: priority,
      speciality: speciality,
      reason: reason,
      appt_profile: apptProfile,
      accepted: 1,
      notification: null,
    };

    try {
      if (id === 0) {
        const data = Encrypt_Value(article, "vozo");
        const response = await axiosInstance.post(
          "/vozo/appointment_waitlist/create",
          data
        );

        const decryptedResponse = Decrypt_Value(response.data, "vozo");
        console.log(decryptedResponse);

        if (response.status === 200 || response.status === 201) {
          resetForm();
          setAddModalShow(false);
          dataFetch();
          setSuccessMsg("Waitlist appointment created successfully!");
          setSuccessAlertShow(true);
        }
      } else {
        article.id = id;
        const data = Encrypt_Value(article, "vozo");
        const response = await axiosInstance.put(
          "/vozo/appointment_waitlist/update",
          data
        );

        if (response.status === 200) {
          setAddModalShow(false);
          dataFetch();
          setSuccessMsg("Waitlist appointment updated successfully!");
          setSuccessAlertShow(true);
          dispatch(
            openToModifyWaitlist({
              data: {},
              value: false,
            })
          );
        }
      }
    } catch (error) {
      console.error("Error in waitlist operation:", error);
    } finally {
      setTimeout(() => {
        setSuccessAlertShow(false);
        setTimeout(() => setSuccessMsg(""), 1000);
      }, 2000);
      setSubmitLoading(false);
    }
  };

  const resetForm = () => {
    setPatientId("");
    setPatientSearch("");
    setSelectedPatient(null);
    setApptType("");
    setFacility("");
    setProvider("");
    setApptDate("");
    setPrefStartTime("");
    setPrefEndTime("");
    setPriority("");
    setSpeciality("");
    setReason("");
    setApptProfile("");
    setErrors({
      patientId: "",
      apptType: "",
      facility: "",
      provider: "",
      apptDate: "",
      priority: "",
      speciality: "",
      apptProfile: "",
    });
  };

  const getLabelContent = () => {
    if (!fullFacName) return String(facility);

    const displayText =
      fullFacName.length > 40
        ? `${fullFacName.substring(0, 40)}...`
        : fullFacName;

    // If the parent component supports JSX
    return (
      <span title={fullFacName} placement="topLeft">
        <span>
          {displayText}
          <Tooltip>{fullFacName}</Tooltip>
        </span>
      </span>
    );
  };

  const fetchPatients = async (searchValue = "") => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(async () => {
      setLoading(true);

      let alle_data =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id +
        "&activepatlist=" +
        1;

      if (searchValue && searchValue.trim() !== "") {
        alle_data += "&fname=" + searchValue.toLowerCase();
      }

      let alle_data_enc = Encrypt_Value(alle_data, "vozo");

      try {
        const response = await axiosInstance.get(
          "/vozo/patientsearch?search=" + alle_data_enc
        );
        let temp_role = Decrypt_Value(response.data, "vozo");
        setPatients(temp_role);
      } catch (error) {
        console.error("Error fetching patients:", error);
        setPatients([]);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const fetchPatientName = async (pid) => {
    try {
      const response = await axiosInstance.get(`vozonew/patient?pid=${pid}`);
      const decryptedResponse = Decrypt_Value(response.data, "vozo");
      const patName = decryptedResponse.fname + " " + decryptedResponse.lname;

      setSelectedPatient({
        value: pid,
        label: patName,
      });
      setPatientId(pid);

      return patName;
    } catch (error) {
      console.error("Error fetching patient name:", error);
      return null;
    }
  };

  const handlePatientSearch = (value) => {
    setPatientSearch(value);
    fetchPatients(value);
    clearError("patientId");
  };

  const handlePatientSelect = (option) => {
    if (option && option.value) {
      setPatientId(option.value);
      setSelectedPatient({
        value: option.value,
        label: option.label,
      });
      clearError("patientId");
    }
  };

  const handleApptTypeChange = (selectedOption) => {
    setApptType(selectedOption.value);
    clearError("apptType");
  };

  const handleFacilityChange = (selectedOption) => {
    setFacility(selectedOption.value);
    clearError("facility");
  };

  const handleProviderChange = (selectedOption) => {
    setProvider(selectedOption.value);
    clearError("provider");
  };

  const handleApptDateChange = (e) => {
    setApptDate(e.target.value);
    clearError("apptDate");
  };

  const handlePriorityChange = (selectedOption) => {
    setPriority(selectedOption.value);
    clearError("priority");
  };

  const handleSpecialityChange = (value) => {
    setSpeciality(value);
    clearError("speciality");
  };

  const handleApptProfileChange = (selectedOption) => {
    setApptProfile(selectedOption.value);
    clearError("apptProfile");
  };

  //-------------------------------------------Function End--------------------------------------------------------

  //-------------------------------------------UseEffect Start--------------------------------------------------------
  useEffect(() => {
    // If editing, populate form with existing data
    if (id !== 0 && row) {
      setPatientId(row.patient_id || "");
      setPatientSearch(row.patient_name || "");
      setApptType(row.appt_type || 0);
      setFacility(row.facility || "");
      setProvider(row.provider || "");
      setApptDate(row.appt_date || "");
      setPrefStartTime(row.pref_start_time || "");
      setPrefEndTime(row.pref_end_time || "");
      setPriority(row.priority || "");
      setSpeciality(row.speciality || "");
      setReason(row.reason || "");
      setApptProfile(row.appt_profile || "");

      // Fetch patient name for edit mode
      if (row.patient_id) {
        fetchPatientName(row.patient_id);
      }
    }

    const handleFetchApptProfile = async () => {
      try {
        const response = await axiosInstance.get("/vozo/appstatus/category");
        const decryptedResponse = Decrypt_Value(response.data, "vozo");
        setApptProfiles(decryptedResponse[2]);
      } catch (err) {
        console.error(err);
      }
    };

    const handleFetchFacility = async () => {
      let Data_frsh_doc =
        "authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&group_id=" +
        group_id;
      let Data_enc_doc = Encrypt_Value(Data_frsh_doc, "vozo");
      try {
        const response = await axiosInstance.get(
          "/vozonew/facility?search=" + Data_enc_doc
        );
        const decryptedResponse = Decrypt_Value(response.data, "vozo");
        setFacilities(decryptedResponse);
      } catch (err) {
        console.error(err);
      }
    };

    handleFetchApptProfile();
    handleFetchFacility();
    fetchPatients();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [id, row]);

  useEffect(() => {
    const handleFetchProvider = async () => {
      let data =
        "pat_share=" +
        storedNames.appt_a +
        "&main_pro=" +
        main_pro +
        "&owner_id=" +
        owner_id +
        "&userID=" +
        userID +
        "&facilityId=" +
        facility +
        "&authorized=" +
        authorized;

      let data1 = Encrypt_Value(data, "vozo");

      let url;
      let user = authorized === "1" ? userID : main_pro;

      if (storedNames.appt_a) {
        url = "/vozonew/provider?search=" + data1;
      } else {
        url = "/vozonew/provider?uid=" + user;
      }

      try {
        const response = await axiosInstance.get(url);
        const decryptedResponse = Decrypt_Value(response.data, "vozo");
        setProviders(decryptedResponse);

        // ✅ Clear provider only when facility changes
        if (lastFacilityRef.current !== facility) {
          setProvider("");
          lastFacilityRef.current = facility;
        }
      } catch (err) {
        console.error(err);
      }
    };

    handleFetchProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row, facility]);

  //-------------------------------------------UseEffect End--------------------------------------------------------

  return (
    <div>
      <Form onSubmit={OnSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>
            {id === 0 ? "Add Waitlist" : "Edit Waitlist"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="patientName">
              <Form.Label>
                Patient Name<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Patient"
                className="w-100"
                labelInValue
                value={selectedPatient}
                onSearch={handlePatientSearch}
                onChange={handlePatientSelect}
                showSearch
                filterOption={false}
                notFoundContent={loading ? "Searching..." : "No patients found"}
                optionFilterProp="children"
                status={errors.patientId ? "error" : ""}
                style={
                  errors.patientId
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                {patients.map((patient) => (
                  <Option
                    key={patient.pid}
                    value={patient.pid}
                    label={patient.title}
                  >
                    {patient.title} {patient.dob ? `- ${patient.dob}` : ""}
                  </Option>
                ))}
              </Select>
              {errors.patientId && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.patientId}
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col} controlId="apptProfile">
              <Form.Label>
                Appointment Profile<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Appointment Profile"
                className="w-100"
                labelInValue
                value={
                  apptProfile === "" ||
                  apptProfile === null ||
                  apptProfile === undefined
                    ? undefined
                    : {
                        value: apptProfile,
                        label:
                          apptProfiles.find(
                            (p) => p.value === String(apptProfile)
                          )?.text || "",
                      }
                }
                onChange={handleApptProfileChange}
                status={errors.apptProfile ? "error" : ""}
                style={
                  errors.apptProfile
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Appointment Profile
                </Option>
                {apptProfiles.map((profile) => (
                  <Option key={profile.value} value={profile.value}>
                    {profile.text}
                  </Option>
                ))}
              </Select>
              {errors.apptProfile && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.apptProfile}
                </div>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="apptType">
              <Form.Label>
                Appointment Type<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Appointment Type"
                className="w-100"
                labelInValue
                value={
                  apptType === "" || apptType === null || apptType === undefined
                    ? undefined
                    : {
                        value: apptType,
                        label:
                          apptTypes.find((type) => {
                            // Handle the case where apptType is 0
                            if (apptType === 0) {
                              return type.id === 0;
                            }
                            return type.id === apptType;
                          })?.name || "",
                      }
                }
                onChange={handleApptTypeChange}
                status={errors.apptType ? "error" : ""}
                style={
                  errors.apptType
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Appointment Type
                </Option>
                {apptTypes.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.name}
                  </Option>
                ))}
              </Select>
              {errors.apptType && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.apptType}
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col} controlId="facility">
              <Form.Label>
                Facility<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Facility"
                className="w-100 truncate-select"
                labelInValue
                value={
                  facility === "" || facility === null || facility === undefined
                    ? undefined
                    : {
                        value: facility,
                        label: getLabelContent(),
                      }
                }
                onChange={handleFacilityChange}
                status={errors.facility ? "error" : ""}
                style={
                  errors.facility
                    ? { border: "1px solid #ff4d4f", borderRadius: "6px" }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Facility
                </Option>
                {facilities.map((fac) => {
                  const truncated = fac.name;
                  return (
                    <Option key={fac.id} value={fac.id}>
                      {fac.name}
                      {/* <Tooltip title={fac.name} placement="topLeft">
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "100%",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                          }}
                        >
                          {fac.name}
                        </span>
                      </Tooltip> */}
                    </Option>
                  );
                })}
              </Select>

              {errors.facility && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.facility}
                </div>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="apptDate">
              <Form.Label>
                Date<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={apptDate}
                onChange={handleApptDateChange}
                isInvalid={!!errors.apptDate}
                min={getTodayDate()}
                style={
                  errors.apptDate
                    ? {
                        border: "1px solid #ff4d4f",
                      }
                    : {}
                }
              />
              {errors.apptDate && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.apptDate}
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col} controlId="prefStartTime">
              <Form.Label>
                From Time<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <TimePicker
                use12Hours
                format="h:mm A"
                minuteStep={1}
                className="w-100"
                value={prefStartTime ? moment(prefStartTime, "HH:mm") : null}
                status={errors.fromTime ? "error" : ""}
                style={
                  errors.fromTime
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
                onChange={(timeObj) => {
                  if (!timeObj) return;

                  const startTime = timeObj.format("HH:mm");
                  clearError("toTime");

                  const newErrors = { ...errors };

                  // Validation: prevent selecting past time if date is today
                  if (
                    apptDate === getTodayDate() &&
                    startTime < moment().format("HH:mm")
                  ) {
                    newErrors.fromTime = "Cannot select past time";
                    setErrors(newErrors);
                    setPrefEndTime("");
                    return;
                  }

                  newErrors.fromTime = "";
                  setErrors(newErrors);

                  setPrefStartTime(startTime);
                  clearError("fromTime");

                  // Reset end time if it becomes invalid
                  if (prefEndTime && startTime >= prefEndTime) {
                    setPrefEndTime("");
                  }
                }}
              />
              {errors.fromTime && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.fromTime}
                </div>
              )}
            </Form.Group>

            <Form.Group as={Col} controlId="prefEndTime">
              <Form.Label>
                To Time<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <TimePicker
                use12Hours
                format="h:mm A"
                minuteStep={1}
                className="w-100"
                value={prefEndTime ? moment(prefEndTime, "HH:mm") : null}
                disabled={!prefStartTime} // Disable until fromTime is selected
                status={errors.toTime ? "error" : ""}
                style={
                  errors.toTime
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
                onChange={(timeObj) => {
                  if (!timeObj) return;

                  const endTime = timeObj.format("HH:mm");
                  clearError("toTime");

                  const newErrors = { ...errors };

                  // Validate end time > start time
                  if (prefStartTime && endTime <= prefStartTime) {
                    newErrors.toTime =
                      "End Time has to be greater than start time";
                    setErrors(newErrors);
                    setPrefEndTime("");
                    return;
                  }

                  // Validate not a past time (for today)
                  if (
                    apptDate === getTodayDate() &&
                    endTime < moment().format("HH:mm")
                  ) {
                    newErrors.toTime = "Cannot select past time";
                    setErrors(newErrors);
                    setPrefEndTime("");
                    return;
                  }

                  newErrors.toTime = "";
                  setErrors(newErrors);

                  setPrefEndTime(endTime);
                }}
              />
              {errors.toTime && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.toTime}
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col}></Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="speciality">
              <Form.Label>
                Specialty<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Specialty"
                className="w-100"
                value={speciality || undefined}
                onChange={handleSpecialityChange}
                status={errors.speciality ? "error" : ""}
                style={
                  errors.speciality
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Specialty
                </Option>
                {specialityList &&
                  specialityList.map((spec, index) => {
                    return (
                      <Option key={index} value={spec}>
                        {spec}
                      </Option>
                    );
                  })}
              </Select>
              {errors.speciality && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.speciality}
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col} controlId="provider">
              <Form.Label>
                Provider<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Provider"
                className="w-100"
                labelInValue
                value={
                  provider === "" || provider === null || provider === undefined
                    ? undefined // This will show the placeholder
                    : {
                        value: provider,
                        label:
                          providers.filter(
                            (prov) => String(prov.id) === provider
                          )[0]?.text ||
                          row?.provider_name ||
                          "",
                      }
                }
                onChange={handleProviderChange}
                status={errors.provider ? "error" : ""}
                style={
                  errors.provider
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Provider
                </Option>
                {providers.map((prov) => (
                  <Option key={prov.id} value={prov.id}>
                    {prov.text}
                  </Option>
                ))}
              </Select>
              {errors.provider && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.provider}
                </div>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="priority">
              <Form.Label>
                Priority<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                suffixIcon={<CustomSuffixIcon />}
                placeholder="Select Priority"
                className="w-100"
                labelInValue
                value={
                  priority === "" || priority === null || priority === undefined
                    ? undefined // This will show the placeholder
                    : {
                        value: priority,
                        label:
                          priorities.find((p) => p.id === Number(priority))
                            ?.name || "",
                      }
                }
                onChange={handlePriorityChange}
                status={errors.priority ? "error" : ""}
                style={
                  errors.priority
                    ? {
                        border: "1px solid #ff4d4f",
                        borderRadius: "6px",
                      }
                    : {}
                }
              >
                <Option value="" disabled>
                  Select Priority
                </Option>
                {priorities.map((pri) => (
                  <Option key={pri.id} value={pri.id}>
                    {pri.name}
                  </Option>
                ))}
              </Select>
              {errors.priority && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                >
                  {errors.priority}
                </div>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="reason">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter reason for waitlist appointment"
                value={reason || ""}
                onChange={(e) => setReason(e.target.value)}
                style={{
                  resize: "vertical",
                  minHeight: "80px",
                }}
                // Add CSS classes for placeholder styling
                className="custom-textarea"
              />
              <style>
                {`
                  .custom-textarea::placeholder {
                    color: #aaaaaa !important;
                    opacity: 1 !important;
                  }
                  .custom-textarea:-ms-input-placeholder {
                    color: #aaaaaa !important;
                  }
                  .custom-textarea::-ms-input-placeholder {
                    color: #aaaaaa !important;
                  }
                `}
              </style>
            </Form.Group>
          </Form.Row>
          <Modal.Footer>
            <Button
              className="close-btn"
              variant="light"
              onClick={() => {
                dispatch(
                  openToModifyWaitlist({
                    data: {},
                    value: false,
                  })
                );
                setAddModalShow(false);
              }}
            >
              Cancel
            </Button>

            <Button
              className="save-btn"
              type="submit"
              variant="primary"
              disabled={submitLoading}
            >
              {submitLoading ? "Saving..." : "Save"}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Form>
    </div>
  );
}

export default memo(WaitlistModal);
